import { ModuleWithProviders, NgModule } from '@angular/core';

import {FroalaEditorModule} from './editor';
import {FroalaViewModule} from './view';

export {
  FroalaEditorDirective,
  FroalaEditorModule
} from './editor';

export {
  FroalaViewDirective,
  FroalaViewModule
} from './view';

const MODULES = [
  FroalaEditorModule,
  FroalaViewModule
]


export class FERootModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
 imports: [
   FroalaEditorModule.forRoot(),
   FroalaViewModule.forRoot()
 ],
 exports: MODULES
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
